/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { updateAgreementInfo } from 'state/actions/session_status';
import { changePage, updatePageDetails } from "@insticator/insticator-ui";

// component
import AcceptAgreement from 'pages/auth/acceptagreement/acceptagreement';

/* ========== ~~~~~~~~~~ AUTH SignUpComplete : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ sessionStatus }) => ({
    agreementUUID: sessionStatus.agreementUUID,
    userUUID: sessionStatus.userUUID
});

// map actions
const mapDispatchToProps = dispatch => ({
    updateAgreementInfo: (agreementUUID, userUUID, callback) => dispatch(updateAgreementInfo(agreementUUID, userUUID, callback)),
    moveToPage: (location) => {
        dispatch(updatePageDetails(location));
        dispatch(changePage(location))
    },
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AcceptAgreement);
